import { RunningExperiments, useExperiments } from 'state/experiments';

export const useModifierRedesignPhaseTwo = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ModifierRedesignPhase2, 'treatment', { skipExposureLogging });
};
